export const getFormAsObject = form => Object.values(form).reduce((obj, element) => {
  if (element.name) {
    obj[element.name] = element.value;
  }
  return obj;
}, {});